import { HttpClient, HttpContext, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom, Observable, Subject, takeUntil, timeout } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpService {

  defaultTimeout: number = 40000;
  timeout: number = this.defaultTimeout;

  constructor(private http: HttpClient) { }

  options(): RequestOptions {
    return {
      headers: new HttpHeaders({
      }),
      withCredentials: true
    };
  }

  setTimeout(value: number) {
    this.timeout = value;
  }

  resetTimeout() {
    this.timeout = this.defaultTimeout;
  }
  async post<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.postObservable(url, arg, destroy$, options));
  }

  postObservable<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Observable<T> {
    // console.log('Timeout: ' + this.timeout);
    if (destroy$) {
      return this.http.post<T>(`${url}`, arg, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.post<T>(`${url}`, arg, options).pipe(timeout(this.timeout));
    }
  }

  async get<T>(url: string, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.getObservable(url, destroy$, options));
  }

  async getFile<T>(url: string, destroy$: Subject<void> | null = null, options: any): Promise<T> {
    return await lastValueFrom(this.getObservable(url, destroy$, options));
  }


  getObservable<T>(url: string, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.get<T>(url, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.get<T>(url, options).pipe(timeout(this.timeout));
    }
  }

  async put<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.putObservable(url, arg, destroy$, options));
  }

  putObservable<T, K>(url: string, arg: K, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.put<T>(`${url}`, arg, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.put<T>(`${url}`, arg, options).pipe(timeout(this.timeout));
    }
  }

  async delete<T>(url: string, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Promise<T> {
    return await lastValueFrom(this.deleteObservable(url, destroy$, options));
  }

  deleteObservable<T>(url: string, destroy$: Subject<void> | null = null, options: RequestOptions = this.options()): Observable<T> {
    if (destroy$) {
      return this.http.delete<T>(url, options).pipe(takeUntil(destroy$), timeout(this.timeout));
    } else {
      return this.http.delete<T>(url, options).pipe(timeout(this.timeout));
    }
  }
}

interface RequestOptions {
  headers?: HttpHeaders;
  params?: HttpParams | Record<string, string | number | boolean | ReadonlyArray<string | number | boolean>>;
  withCredentials?: boolean;
  /** Per-request tokens, e.g. HANDLED_ERROR_STATUSES so the caller renders the error inline. */
  context?: HttpContext;
}
